import type { PublicStoreMenuCustomizationGroup } from '~/services/api/menus/public/useMenusPublicService'
import type { Customization } from '~/types/Customization'

export const mapCustomizationGroup = (group: PublicStoreMenuCustomizationGroup): Customization => ({
  allow_multiple_selections: group.allow_multiple_selections,
  allow_repeated_selection: group.allow_repeated_selection,
  description: group.description,
  id: group.id,
  is_required: group.is_required,
  max_per_option: group.max_per_option,
  max_selections: group.max_selections,
  max_total_selections: group.max_total_selections,
  min_selections: group.min_selections,
  name: group.name,
  options: group.options.map((option) => ({
    ...(option.description === null ? {} : { description: option.description }),
    effective_price: option.effective_price,
    id: option.id,
    is_available: option.is_available,
    name: option.name,
    price_adjustment: option.price_adjustment,
    pricing_model: option.pricing_model,
    sort_order: option.sort_order
  })),
  sort_order: group.sort_order
})
